import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-uppercase text-center" }, " Biên bản kiểm nghiệm sản phẩm, vật tư, hàng hóa ")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "text-center pt-5" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_11 = { class: "col-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "text-center pt-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "d-flex justify-content-center align-items-center my-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "me-4 mb-0" }, "Tổng cộng:", -1)
const _hoisted_18 = { style: {"width":"20%"} }
const _hoisted_19 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center mb-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "me-4 mb-0" }, "Tổng số tiền (viết bằng chữ):", -1)
const _hoisted_21 = { style: {"width":"60%"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "row mt-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_25 = { class: "col-10" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, " Ý kiến Hội Đồng kiểm nghiệm: ", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_29 = { class: "row mt-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, null, -1)
const _hoisted_31 = { class: "col-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_VatTuBienBanTable = _resolveComponent("VatTuBienBanTable")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, _createSlots({
    "page-row-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Chỉnh sửa vật tư'), 1)
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "onClick"])
    ]),
    _: 2
  }, [
    (_ctx.hopDongDetail)
      ? {
          name: "page-row-content",
          fn: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.rules,
              onSubmit: _withModifiers(() => {}, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_ResponsiveLayout, { justify: "space-between" }, {
                  "col-1": _withCtx(() => [
                    _createVNode(_component_LabelCustom, {
                      "is-bolder": true,
                      class: "me-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ngày:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      prop: "ngayKiemNghiem"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "w-100",
                          modelValue: _ctx.form.ngayKiemNghiem,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.ngayKiemNghiem) = $event)),
                          disabled: !_ctx.isCreating,
                          placeholder: "Chọn ngày",
                          name: "ngayNhapKho",
                          format: "DD/MM/YYYY"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(_component_LabelCustom, {
                      "is-bolder": true,
                      class: "me-3"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass({ required: _ctx.isCreating })
                        }, " Nhập tại kho: ", 2)
                      ]),
                      _: 1
                    })
                  ]),
                  "col-4": _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.idKho,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.idKho) = $event)),
                      class: "w-100",
                      disabled: !_ctx.isCreating,
                      placeholder: "Chọn kho",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableKhoItems, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.value,
                            label: option.label,
                            value: option.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                (!_ctx.isCreating && _ctx.soPhieuNhap && _ctx.idPhieuNhapKho)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("p", _hoisted_3, [
                        _createTextVNode("Phiếu nhập số "),
                        _createElementVNode("span", null, [
                          _createVNode(_component_RouterLink, {
                            target: "_blank",
                            to: {
                name: 'chi-tiet-phieu-nhap-kho',
                params: {
                  id: _ctx.idPhieuNhapKho,
                },
              }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.soPhieuNhap), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createTextVNode(" thuộc hợp đồng số "),
                          (_ctx.hopDongDetail)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 0,
                                target: "_blank",
                                to: {
              name: 'chi-tiet-hop-dong',
              params: {
                id: _ctx.hopDongDetail.id
              },
            }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.hopDongDetail.so_hop_dong), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_4, [
                    _createTextVNode(" Căn cứ theo quyết định của Giám đốc "),
                    _createElementVNode("span", null, [
                      _createVNode(_component_el_form_item, {
                        prop: "tenGiamDoc",
                        class: "d-inline-block"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.tenGiamDoc,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.tenGiamDoc) = $event)),
                            disabled: !_ctx.isCreating,
                            placeholder: "Mời nhập tên",
                            name: "tenGiamDoc"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createTextVNode(" về việc thành lập hội đồng kiểm nghiệm. Hội đồng kiểm nghiệm gồm các ông (bà) có tên sau đây: ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_table, {
                      size: "small",
                      "cell-style": {padding: '0', height: '15px'},
                      border: true,
                      data: _ctx.hoiDongKiemNghiem
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "STT",
                          width: "50"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.thuTu), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Họ và tên" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.hoiDongKiemNghiem[scope.$index].hoTen,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.hoiDongKiemNghiem[scope.$index].hoTen) = $event),
                              placeholder: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Chức vụ chuyên môn" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.hoiDongKiemNghiem[scope.$index].chucVu,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.hoiDongKiemNghiem[scope.$index].chucVu) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Thành phần trong hội đồng" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.hoiDongKiemNghiem[scope.$index].thanhPhan,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.hoiDongKiemNghiem[scope.$index].thanhPhan) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.ADD,
                      onClick: _ctx.onAddNguoiKiemNghiem
                    }, null, 8, ["button-type", "onClick"]),
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.MINUS,
                      "is-disabled": _ctx.hoiDongKiemNghiem.length === 1,
                      "color-type": _ctx.ButtonTypeColors.DANGER,
                      onClick: _ctx.onDeleteNguoiKiemNghiem
                    }, null, 8, ["button-type", "is-disabled", "color-type", "onClick"])
                  ]),
                  _hoisted_12
                ]),
                _hoisted_13,
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_14, [
                    _createTextVNode(" Đã tiến hành kiểm nghiệm các loại vật tư theo hợp đồng số "),
                    _createElementVNode("i", null, _toDisplayString(_ctx.hopDongDetail?.so_hop_dong), 1),
                    _createTextVNode(" ngày "),
                    _createElementVNode("i", null, _toDisplayString(_ctx.moment(_ctx.hopDongDetail?.ngay_ky).format('DD/MM/YYYY')), 1),
                    _createTextVNode(" như sau: ")
                  ])
                ]),
                _hoisted_15,
                (_ctx.vatTuBienBanItems.length)
                  ? (_openBlock(), _createBlock(_component_VatTuBienBanTable, {
                      key: 1,
                      "allow-editing-don-gia": _ctx.allowEditingDonGia,
                      "for-phieu-nhap-le": false,
                      vatTuItems: _ctx.vatTuBienBanItems,
                      onChangeDonGia: _ctx.handleDonGiaUpdate,
                      onOnChange: _ctx.onInputChange,
                      onOnChangePhuongThuc: _ctx.onInputPhuongThuc
                    }, null, 8, ["allow-editing-don-gia", "vatTuItems", "onChangeDonGia", "onOnChange", "onOnChangePhuongThuc"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.totalPriceInNumber,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.totalPriceInNumber) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (_ctx.changed || !_ctx.isCreating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.totalPriceInText,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.totalPriceInText) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fw-bold fs-6 mb-5", { required: _ctx.isCreating }])
                    }, _hoisted_27, 2),
                    _createVNode(_component_el_form_item, { prop: "yKien" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          disabled: !_ctx.isCreating,
                          type: "textarea",
                          placeholder: "Mời nhập ý kiến",
                          modelValue: _ctx.form.yKien,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.yKien) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.SAVE,
                      "color-type": _ctx.ButtonTypeColors.SUCCESS,
                      onClick: _ctx.onSubmit
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isCreating ? 'Tạo B/b' : 'Lưu chỉnh sửa'), 1)
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type", "onClick"])
                  ]),
                  _hoisted_32
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}